import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputContainer from '../../citizen/TCPForms/layout/inputContainer';
import { useForm } from "react-hook-form";
import ButtonWrapper from '../../citizen/TCPForms/components/Button';
import {styled} from '@material-ui/core'


const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: '20px',
      width: '25ch',
    },
  },
  formControl: {
    margin: '20px',
    width: '260px'
  },
}));

const FilterForm = () => {
  const classes = useStyles();
  const { handleSubmit, control } = useForm();
  const onSubmit = (data) => {
    console.log(data);
  }

  return (
    <section className="container1" style={{width:"99%"}}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">
              Application Reports
            </h2>
          </div>
          <div className="formInputContainer">
            <div className="columnWrapper">
            <InputContainer
                label="Applicant Name"
                control={control}
                placeholder="Enter Applicant Name"
                name="applicantName"
                type="textInput"
                mandatory
                // width={'255px'}
              />
              <InputContainer
                label="Applicant/Ref No"
                control={control}
                placeholder="Enter Applicantion No"
                name="applicationNo"
                type="textInput"
                mandatory
                // width={'255px'}
              />
              <InputContainer
                control={control}
                label="Status :"
                data={[{ value: 'Applied', label: 'Applied' },
                { value: 'InProgress', label: 'InProgress' },
                { value: 'Progress', label: 'Progress' },
                { value: 'Approved', label: 'Approved' },
                { value: 'Rejected', label: 'Rejected' },]}
                placeholder="Status"
                name="status"
                mandatory
                type="selectInput"
              />
              <InputContainer
                label="Applied by"
                control={control}
                placeholder="Applied By"
                data={[
                  { value: 'TechnicalPrivateProfessionals', label: 'Technical Private Professionals' },
                  { value: 'StructuralEngineers', label: 'Structural Engineers' },
                  { value: 'TownPlanners', label: 'Town Planners' },
                ]
                }
                name="appliedBy"
                type="selectInput"
                mandatory
              />
              <InputContainer
                label="From Date"
                control={control}
                placeholder="From Date"
                name="fromDate"
                type="datePicker"
              />
              <InputContainer
                label="To Date"
                control={control}
                placeholder="To Date"
                name="To Date"
                type="datePicker"
              />
              <InputContainer
                label="Form No"
                control={control}
                placeholder="Form"
                data={[
                  { value: 'Form11', label: 'Form11' },
                  { value: 'Form12', label: 'Form12' },
                  { value: 'Form26', label: 'Form26' },
                  { value: 'Form34', label: 'Form34' },
                ]
                }
                name="formno"
                type="selectInput"
                mandatory
              />

            </div>
            <div className="columnWrapper">
              <InputContainer
                label="District"
                control={control}
                placeholder="District"
                name="district"
                data={[ { value: 'Solan', label: 'Solan' },
                { value: 'Shimla', label: 'Shimla' },
                { value: 'BilasPur', label: 'BilasPur' },]}
                mandatory
                type="selectInput"
              />
              <InputContainer
                label="Area Type"
                control={control}
                placeholder="Area Type"
                name="areaType"
                mandatory
                data={[
                  { value: 'PlanningArea', label: 'Planning Area' },
                   { value: 'SpecialArea', label: 'Special Area' },
                ]}
                type="selectInput"
              />
              <InputContainer
                label="Notified Area"
                control={control}
                placeholder="Notified Area"
                name="notifiedArea"
                data={[{ value: 'Harat', label: 'Harat' },
                { value: 'Hinner', label: 'Hinner' },
                { value: 'Shimla', label: 'Shimla' },]}
                mandatory
                type="selectInput"
              />
              <InputContainer
                label="Application Type"
                control={control}
                placeholder="Application Type"
                name="applicationType"
                data={[{ value: 'BuildingPlan', label: 'Building Plan' },
                { value: 'Composition', label: 'Composition' },
                { value: 'NoObjection', label: 'No Objection' },]}
                mandatory
                type="selectInput"
              />
              <InputContainer
                label="Ranges"
                control={control}
                placeholder="Ranges"
                name="ranges"
                data={[{ value: 'Under500', label: 'Under 500' },
                { value: 'Above500', label: 'Above 500' },
                { value: 'Below2500', label: 'Below 2500' },
              ]}
                mandatory
                type="selectInput"
              />
              <InputContainer
                label="Use Type"
                control={control}
                placeholder="Use Type"
                name="useType"
                data={[{ value: 'Residential', label: 'Residential' },
                { value: 'Commercial', label: 'Commercial' },
                { value: 'Industrial', label: 'Industrial' },]}
                mandatory
                type="selectInput"
              />
              <InputContainer
                label="Select CLU Type"
                control={control}
                placeholder="CLU Type"
                name="cluType"
                data={[{ value: 'Residential', label: 'Residential' },
                { value: 'Commercial', label: 'Commercial' },
                { value: 'Industrial', label: 'Industrial' },]}
                mandatory
                type="selectInput"
              />
            </div>
          </div>
        </div>
        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="success"
              size="medium"
              label="Search"
              type="submit"
              onClick={handleSubmit}
            />
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Reset"
            />
          </div>
        </div>
      </form>
    </section>
  );
};

export default FilterForm;
